import React from 'react';
import SortableTableHeader from 'components/pure/sortable-tables/SortableTableHeader';
import TrendChartContainer from './TrendChartContainer';
import {BarChartIcon} from '@components/icon/BarChartIcon';
import Popper from '@material-ui/core/Popper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

export default class TableHeaderSkill extends React.Component {
  constructor(props) {
    super(props);
    this.barsClick = this.barsClick.bind(this);
    this.onPopoverRequestClose = this.onPopoverRequestClose.bind(this);

    this.state = {
      openPopover: false,
    };
  }

  barsClick(e, skill) {
    e.stopPropagation();
    e.preventDefault();
    if (this.props.headerTooltip) {
      this.props.headerTooltip(skill);

      this.setState({
        openPopover: true,
      });
    }
  }

  onPopoverRequestClose() {
    this.setState({
      openPopover: false,
    });
  }

  render() {
    const {
      label,
      skill,
      renderColumn,
      sortColumn,
      sortDirection,
      className,
      chartTitle,
      startDate,
      endDate,
    } = this.props;
    return (
      <th
        className={className}
        onClick={this.props.onClick}
        onMouseEnter={this.props.onMouseEnter}
        onMouseLeave={this.props.onMouseLeave}
        ref={c => (this.popoverAnchor = c)}>
        <SortableTableHeader
          label={label}
          renderColumn={renderColumn}
          sortColumn={sortColumn}
          sortDirection={sortDirection}
        />
        {this.props.headerTooltip && (
          <div className={'bars-icon index'} onClick={e => this.barsClick(e, skill)}>
            <BarChartIcon tooltip="Over time chart" />
          </div>
        )}
        {this.state.openPopover && (
          <ClickAwayListener onClickAway={this.onPopoverRequestClose}>
            <Popper
              open
              anchorEl={this.popoverAnchor}
              anchorOrigin={{horizontal: 'middle', vertical: 'top'}}
              targetOrigin={{horizontal: 'middle', vertical: 'bottom'}}
              className="skill-popover destyle-popover">
              <div className="tooltip-container">
                <div className="ev-tooltip">
                  <div className="tooltip-content">
                    <TrendChartContainer
                      startDate={startDate}
                      endDate={endDate}
                      chartLabel={chartTitle}
                      onClose={this.onPopoverRequestClose}
                    />
                  </div>
                </div>
              </div>
            </Popper>
          </ClickAwayListener>
        )}
      </th>
    );
  }
}
